import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataReservation } from '../../data/DataReservation';
import { Immocom } from '../../specifique/immocom';
import { EUIDatePicker } from '../EUI/EUIDatePicker';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    idLotCommercial
    peutModifierBlocDateReservation

    onAffichePanelCalendrierReservation : bool
    onAffichageSansPanel: bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    onChange : méthode appelée si onAffichageSansPanel = true
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)
****************************************************************/

var objetState = {
    reservation: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelCalendrierReservation: 'Renseigner les dates de la réservation',

    onActiveBoutonEnregistrer: false,

    activationSignatureClient: false,
    activationValidation: false,
    activationSignatureEiffage: false,
    activationSignatureActe: false,
    signatureActeSelectionnee: false
};

export class FicheCalendrierReservation extends Component {

    _creationContent = () => {

        const aujourdhui = new Date(Date.now());
        const estSigneElectroniqueClient = this.state.reservation.dateSignatureElectronique !== null;
        const estSigneElectroniqueEiffage = this.state.reservation.dateSignatureEiffageElectronique !== null;

        return <div className="ms-Grid" dir="ltr">

            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3 labelDateReservation">Date prévisionnelle</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3 labelDateReservation">Date réelle</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3 labelDateReservation">Date retour AR</div>
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de réservation</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3">
                    <EUIDatePicker
                        allowTextInput={false}
                        isRequired
                        maxDate={aujourdhui}
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateReservation", Scriba.date().getChaineISOFromDate(e))}
                        placeholder="Date réelle"
                        value={this.state.reservation.dateReservation}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de réception du contrat de réservation</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateReceptionContratReservation">
                    <EUIDatePicker
                        maxDate={aujourdhui}
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateReceptionContratReservation", Scriba.date().getChaineISOFromDate(e))}
                        placeholder="Date réelle"
                        value={this.state.reservation.dateReceptionContratReservation}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de signature client {(estSigneElectroniqueClient ? '(électronique)' : null)}</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3">
                    <EUIDatePicker
                        allowTextInput={false}
                        disabled={!(this.props.peutModifierBlocDateReservation && this.state.activationSignatureClient) || estSigneElectroniqueClient}
                        maxDate={aujourdhui}
                        onClear={e => this._onMiseAJourChamp("reservation", "dateDeSignatureManuelle", null)}
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateDeSignatureManuelle", Scriba.date().getChaineISOFromDate(e))}
                        placeholder="Date réelle"
                        value={estSigneElectroniqueClient ? this.state.reservation.dateSignatureElectronique : this.state.reservation.dateDeSignatureManuelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de signature Eiffage {(estSigneElectroniqueEiffage ? '(électronique)' : null)}</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3">
                    <EUIDatePicker
                        allowTextInput={false}
                        disabled={(!(this.props.peutModifierBlocDateReservation && this.state.activationSignatureEiffage) || estSigneElectroniqueEiffage) || this.state.signatureActeSelectionnee}
                        maxDate={aujourdhui}
                        onClear={e => this._onMiseAJourChamp("reservation", "dateDeSignatureEiffageManuelle", null)}
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateDeSignatureEiffageManuelle", Scriba.date().getChaineISOFromDate(e))}
                        placeholder="Date réelle"
                        value={estSigneElectroniqueEiffage ? this.state.reservation.dateSignatureEiffageElectronique : this.state.reservation.dateDeSignatureEiffageManuelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de notification promoteur</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateNotificationPromoteur">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateNotificationPromoteur", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateNotificationPromoteur}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateNotificationPromoteurRetourAR">
                    <EUIDatePicker
                        placeholder="Date retour AR"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateNotificationPromoteurRetourAR", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateNotificationPromoteurRetourAR}
                    />
                </div>
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date d'envoi du contrat au notaire</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateEnvoiContratNotaire">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateEnvoiContratNotaire", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateEnvoiContratNotaire}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date d'acceptation de l'offre de prêt</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateAcceptationPretPrevisionnelle">
                    <EUIDatePicker
                        placeholder="Date prévisionnelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateAcceptationPretPrevisionnelle", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateAcceptationPretPrevisionnelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateAcceptationPret">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateAcceptationPret", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateAcceptationPret}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de notification notaire</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateNotificationNotaire">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateNotificationNotaire", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateNotificationNotaire}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateNotificationNotaireRetourAR">
                    <EUIDatePicker
                        placeholder="Date retour AR"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateNotificationNotaireRetourAR", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateNotificationNotaireRetourAR}
                    />
                </div>
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de signature de l'acte</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateSignatureActePrevisionnelle">
                    <EUIDatePicker
                        placeholder="Date prévisionnelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateSignatureActePrevisionnelle", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateSignatureActePrevisionnelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateSignatureActe">
                    <EUIDatePicker
                        allowTextInput={false}
                        disabled={!(this.props.peutModifierBlocDateReservation && this.state.activationSignatureActe)}
                        maxDate={aujourdhui}
                        onClear={e => this._onMiseAJourChampPourEnableChampEiffage("reservation", "dateSignatureActe", null)}
                        onSelectDate={e => this._onMiseAJourChampPourDisableChampEiffage("reservation", "dateSignatureActe", Scriba.date().getChaineISOFromDate(e))}
                        placeholder="Date réelle"
                        value={this.state.reservation.dateSignatureActe}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de livraison</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateLivraisonPrevisionnelle">
                    <EUIDatePicker
                        placeholder="Date prévisionnelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateLivraisonPrevisionnelle", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateLivraisonPrevisionnelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateLivraison">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateLivraison", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateLivraison}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row ligneDatesReservation">
                <div className="ms-Grid-col ms-sm12 ms-xl3">Date de quitus</div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateQuitusPrevisionnelle">
                    <EUIDatePicker
                        placeholder="Date prévisionnelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateQuitusPrevisionnelle", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateQuitusPrevisionnelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" name="divDateQuitusReelle">
                    <EUIDatePicker
                        placeholder="Date réelle"
                        onSelectDate={e => this._onMiseAJourChamp("reservation", "dateQuitusReelle", Scriba.date().getChaineISOFromDate(e))}
                        value={this.state.reservation.dateQuitusReelle}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-xl3" />
            </div>

            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                    <div className="zoneAide">Veuillez renseigner les dates connues. Cet écran est accessible depuis le dossier client à tout moment pour que vous puissiez apporter les compléments d'information nécessaires.</div>
                </div>
            </div>

        </div>;
    }

    constructor(props) {
        super(props);
        this.state = objetState;
    }

    _onInit = () => {
        this.setState(objetState);
    }

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du calendrier de la réservation'
        });

        var ficheReservation_Simple = DataReservation._ficheReservation_Simple(this.props.idOperation, this.props.idReservation);

        ficheReservation_Simple
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let stateTemp = {};
                    stateTemp.reservation = {};

                    if (objetData !== null) {
                        // Modification
                        stateTemp.titrePanelCalendrierReservation = 'Modifier les dates de la réservation';

                        stateTemp.reservation = objetData[0];
                        stateTemp.activationSignatureClient = objetData[3];
                        stateTemp.activationSignatureEiffage = objetData[5];
                        stateTemp.activationSignatureActe = objetData[6];
                    }

                    //YD : 19/08/2020
                    if (stateTemp.reservation.dateReservation === undefined) {
                        stateTemp.reservation.dateReservation = new Date();

                        if (this.props.onAffichageSansPanel) {
                            this.props.onChange("dateReservation", stateTemp.reservation.dateReservation);
                        }
                    }

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp, true, this._onVerificationFormulaire);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du calendrier en cours'
        });

        let miseAJourReservation = DataReservation._miseAJourReservation(this.props.idOperation, this.props.idReservation, this.state.reservation);

        miseAJourReservation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        if (!this.state.enCoursDeTraitement)
            this._chargementDonnees();
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onVerificationFormulaire = () => {
        Immocom.fiche()._validationFormulaire(this, 'CalendrierReservation', this.state.reservation, (this.state.reservation.idReservation > 0 ? 'Modification' : 'Création'));
    }

    _onRenderFooterContent = () => {
        return <div>
            <PrimaryButton onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!this.state.onActiveBoutonEnregistrer}>Enregistrer</PrimaryButton>
            <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
        </div>;
    };

    _onMiseAJourChamp = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    _onMiseAJourChampPourDisableChampEiffage = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
        this.setState({
            signatureActeSelectionnee: true
        });

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    _onMiseAJourChampPourEnableChampEiffage = (nomObjet, nomPropriete, valeur) => {
        Scriba.state().setObjetPropriete(this, nomObjet, nomPropriete, valeur, this._onVerificationFormulaire);
        this.setState({
            signatureActeSelectionnee: false
        });

        if (this.props.onAffichageSansPanel) {
            this.props.onChange(nomPropriete, valeur);
        }
    }

    componentDidMount = () => {

        //YD : 19/08/2020
        if (this.props.onAffichageSansPanel) {
            this._chargementDonnees();
        }

        //YD : 19/08/2020
        //if (this.state.reservation.dateReservation === undefined) {
        //    this._onMiseAJourChamp('reservation', 'dateReservation', new Date());
        //}
    }

    render = () => {
        let content = this._creationContent();

        if (this.props.onAffichageSansPanel) {
            return content;
        }
        else {
            return <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.state.titrePanelCalendrierReservation}
                isOpen={this.props.onAffichePanelCalendrierReservation}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.large}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            {content}
                        </div>
                    </div>
                </div>
            </Panel>;
        }
    }
}